import {
    TransactionActiveStatusAction,
    TransactionActiveStatusActions,
} from '../actions/select-transaction-status.action';
import { TransactionActiveStatusState } from '../state/transaction-active-status.state';

export const initialTransactionActiveStatusState: TransactionActiveStatusState =
    {
        null: {
            status:null,
            index: null,
        },
    };

export function transactionActiveStatusReducer(
    state = initialTransactionActiveStatusState,
    action: TransactionActiveStatusAction
): TransactionActiveStatusState {
    switch (action.type) {
        case TransactionActiveStatusActions.SelectTransactionStatus:
                const newState: TransactionActiveStatusState = { ...state };

                if (newState[action.transactionId]?.index === action.index) {
                    delete newState[action.transactionId];
                    return newState;
                }
                newState[action.transactionId] =
                    {...newState[action.transactionId],
                    status: action.status,
                    index: action.index
                    };

                return newState;
        default:
            return state;
    }
}
